import { Action } from '@ngrx/store';
import { Order } from '@cemex-core/cmx-api/models/order-management/order';
import { PricesPatchResponse } from '@cemex-core/cmx-api/models/prices/prices-patch-res';

export enum PricesActionTypes {
  LOAD = '[Retail Prices] Load',
  LOAD_COMPLETE = '[Retail Prices] Load complete',
  LOAD_ORDER_DETAIL_COMPLETE = '[Retail Prices] Load order detail complete',
  RESET = '[Retail Prices] Reset',
}

export class PricesLoadAction implements Action {
  readonly type = PricesActionTypes.LOAD;

  constructor(public payload: { newOrderCreation: boolean }) {}
}

// Order detail with unitary prices after calling prices
export class PricesOrderDetailLoadCompleteAction implements Action {
  readonly type = PricesActionTypes.LOAD_ORDER_DETAIL_COMPLETE;

  constructor(public payload: Order) {}
}

export class PricesLoadCompleteAction implements Action {
  readonly type = PricesActionTypes.LOAD_COMPLETE;

  constructor(public payload: PricesPatchResponse) {}
}

export class PricesResetAction implements Action {
  readonly type = PricesActionTypes.RESET;

  constructor() {}
}

export type PricesActions =
  | PricesLoadAction
  | PricesLoadCompleteAction
  | PricesOrderDetailLoadCompleteAction
  | PricesResetAction;
